export const USERS_KEY = 'users';

export const usersKey = {
  all: [USERS_KEY],
  lists: (token, companyName) => [...usersKey.all, 'list', token, companyName],
  detail: (token, userId) => [...usersKey.all, 'detail', token, userId],
  search: (token, param, box) => [...usersKey.all, 'search', token, param, box]
};
